var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12564",
    "data-name": "Group 12564",
    transform: "translate(-573 -496)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2733",
    "data-name": "Ellipse 2733",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(573 496)",
    fill: "#f96065",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12563",
    "data-name": "Group 12563",
    transform: "translate(0.616 0.862)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "checked",
    d: "M3.878,74.98,5.4,76.518,15.983,65.942l-1.52-1.5L5.4,73.5h0Z",
    transform: "translate(575.506 437.695)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "checked-2",
    "data-name": "checked",
    d: "M15.983,74.98l-1.519,1.538L3.878,65.942l1.52-1.5L14.464,73.5h0Z",
    transform: "translate(575.506 437.695)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.8d3296e0.svg";
export { ForwardRef as ReactComponent };